document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll("animated-details");

  // Observador para detectar apertura
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const opened = mutation.target;
        if (opened.classList.contains("is-open")) {
          // Cerrar todos los demás
          accordions.forEach((acc) => {
            if (acc !== opened) {
              acc.classList.remove("is-open");
            }
          });
        }
      }
    });
  });

  // Aplicar observador a todos los acordeones
  accordions.forEach((accordion) => {
    observer.observe(accordion, { attributes: true });
  });
});